import { Typography, Card, CardContent, Box, Button } from "@mui/material";
import TelegramIcon from '@mui/icons-material/Telegram';
import EmailIcon from '@mui/icons-material/Email';
import { Link } from "react-router-dom";

const PageSupport = () => {
    return (
        <Card>
            <CardContent>
                <Box
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                    alignItems="center"
                    gap={2}
                    minHeight="50vh"
                >

                    <Typography align='center' variant="h5" sx={{ mb: 2 }}>
                        Для связи с поддержкой используйте следующие контакты:
                    </Typography>

                    <Box sx={{
                        width: '320px',
                        marginLeft: 'auto',
                        marginRight: 'auto',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 2,
                        alignItems: 'center'
                    }}>
                        <Box display="flex" alignItems="center" >
                            <TelegramIcon sx={{ mr: 1 }} />
                            <Typography>
                                @smartcoin_support
                            </Typography>
                        </Box>

                        <Box display="flex" alignItems="center">
                            <EmailIcon sx={{ mr: 1 }} />
                            <Typography>
                                support@smartcoinseller.com
                            </Typography>
                        </Box>


                        <Box display="flex" alignItems="center">
                            <EmailIcon sx={{ mr: 1 }} />
                            <Typography>
                                nik.gerasimenko1995@mail.ru
                            </Typography>
                        </Box>

                        <Button
                            component={Link}
                            to="/support-chat"
                            variant="contained"
                            sx={{ mt: 1 }}
                        >
                            Начать чат
                        </Button>
                    </Box>

                </Box>
            </CardContent>
        </Card>
    );
};

export default PageSupport;